import { useMemo } from "react";

const PARTICLE_COUNT = 18;
const MIN_SIZE = 2;
const MAX_SIZE = 6;
const MIN_DURATION = 8;
const MAX_DURATION = 15;

export function GoldParticles() {
  const particles = useMemo(() => {
    return Array.from({ length: PARTICLE_COUNT }, (_, i) => ({
      id: i,
      size: MIN_SIZE + (i % (MAX_SIZE - MIN_SIZE + 1)),
      left: `${5 + (i * 5.2) % 90}%`,
      top: `${10 + (i * 7) % 80}%`,
      duration: MIN_DURATION + (i % (MAX_DURATION - MIN_DURATION + 1)),
      delay: (i * 0.4) % 5,
    }));
  }, []);

  return (
    <div
      className="pointer-events-none absolute inset-0 overflow-hidden"
      aria-hidden
    >
      {particles.map((p) => (
        <span
          key={p.id}
          className="absolute rounded-full bg-primary/20"
          style={{
            width: p.size,
            height: p.size,
            left: p.left,
            top: p.top,
            animation: `float-particle ${p.duration}s ease-in-out ${p.delay}s infinite`,
          }}
        />
      ))}
    </div>
  );
}
